<div mat-dialog-content class="wizard-content">
  <h1>Questionnaire Input</h1>
  <mat-stepper
    #stepper
    [linear]="true"
    [animationDuration]="'500'"
    (selectionChange)="onStepChange($event)"
  >
    <ng-template matStepperIcon="edit"><mat-icon>check</mat-icon></ng-template>

    @for (step of steps; track step.id) {
      <mat-step [completed]="step.complete" [label]="step.label">
        @if (step.choice === null) {
          <div class="wizard-question-container">
            <p class="wizard-question">{{ step.question }}</p>
            <div class="wizard-answers">
              <button
                type="button"
                mat-raised-button
                (click)="answer(step, true)"
              >
                Yes
              </button>
              <button
                type="button"
                mat-raised-button
                (click)="answer(step, false)"
              >
                No
              </button>
            </div>
          </div>
        } @else if (step.choice === true) {
          <div>
            @switch (step.id) {
              @case ('dtcc') {
                <app-annuity-dialog
                  [templateMode]="true"
                  [compareTemplate]="false"
                  [templateData]="dataDTCC"
                  (templateDataOut)="handleInputMethodOut($event, step)"
                />
              }
              @case ('document') {
                <app-document-reader
                  [templateMode]="true"
                  (templateDataOut)="handleInputMethodOut($event, step)"
                />
              }
              @case ('beacon') {
                <app-annuity-dialog
                  [templateMode]="true"
                  [compareTemplate]="false"
                  [templateData]="dataDTCC"
                  (templateDataOut)="handleInputMethodOut($event, step)"
                />
              }
              @case ('search401k') {
                <app-rixtrema-dialog
                  (templateDataOut)="handleInputMethodOut($event, step)"
                />
              }
            }
          </div>
          <div class="step-actions reverse">
            <button
              type="button"
              matButton="outlined"
              (click)="answer(step, false)"
            >
              Skip this input method
            </button>
          </div>
        } @else {
          <div class="wizard-question-container">
            <p class="wizard-question">This input method will be excluded.</p>
            <button
              type="button"
              mat-button
              (click)="step.choice = true; step.complete = false"
            >
              Include this input method
            </button>
          </div>
        }
      </mat-step>
    }

    <mat-step label="Review" [completed]="false">
      <div class="wizard-question-container">
        @if (hasAnyChoice) {
          <p class="wizard-question">
            The following items will be input into the questionnaire. Would you
            like to proceed?
          </p>
          <div class="answer-choices">
            @for (step of steps; track step.id) {
              @if (step.choice === true) {
                <p>{{ step.label }}</p>
              }
            }
          </div>
        } @else {
          <p class="wizard-question">
            It looks like you have not selected any data. Would you like to
            return to the questionnaire and input manually?
          </p>
          <p>Click on a step above to return to that input method.</p>
        }

        <div class="step-actions">
          <button
            type="button"
            mat-raised-button
            color="accent"
            (click)="finish()"
          >
            Finish
          </button>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</div>

<div mat-dialog-actions class="wizard-actions">
  <button type="button" mat-button (click)="cancel()">Cancel</button>
</div>
